var map = {
	"./templates-4341269_120580.svg": 12757,
	"./templates-4341270_120574.svg": 10330,
	"./templates-4341271_120582.svg": 40990,
	"./templates-4341272_120578.svg": 90016,
	"./templates-4341273_120576.svg": 70829,
	"./templates-4341274_120573.svg": 13193,
	"./templates-4341275_120581.svg": 32249,
	"./templates-4341277_120577.svg": 12216,
	"./templates-4341278_120575.svg": 38691
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90176;